import script from "./UploadFileComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadFileComponent.vue?vue&type=script&setup=true&lang=js"

import "./UploadFileComponent.vue?vue&type=style&index=0&id=5d56eb3c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d56eb3c"]])

export default __exports__